import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 12a8 8 0 0 1 16 0l-16 0","key":"svg-0"}],["path",{"d":"M12 12v6a2 2 0 0 0 4 0","key":"svg-1"}]]

/**
 * IconUmbrella
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItdW1icmVsbGEiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTQgMTJhOCA4IDAgMCAxIDE2IDBsLTE2IDAiIC8+CiAgPHBhdGggZD0iTTEyIDEydjZhMiAyIDAgMCAwIDQgMCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/umbrella
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconUmbrella = createReactComponent('outline', 'umbrella', 'Umbrella', __iconNode);

export default IconUmbrella;